import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from './LoadingScreen';

/* ─────────────────────────────────────────────────────────────
   PROTECTED ROUTE — wraps any page that requires a login.

   Behaviour:
   - Still loading session  → show the loading screen
   - No user (logged out)   → redirect to /login?redirect=<current path>
                              so invite links and deep links work correctly
   - User is logged in      → render the page normally

   Usage in App.js:
     <Route path="/dashboard" element={
       <ProtectedRoute><Dashboard /></ProtectedRoute>
     } />
   ───────────────────────────────────────────────────────────── */
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location          = useLocation();

  if (loading) return <LoadingScreen />;
  if (!user) {
    // Encode the full path + query string so it survives the redirect
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirectTo}`} replace />;
  }

  return children;
}

export default ProtectedRoute;
